import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketName } from '../actions';
import {
  getMarketDisplayName,
  getMarketFetching,
  getFetchNameError
} from '../selectors';
import { toJS } from 'utils/immutableUtils';

const useMarketLabel = () => {
  const dispatch = useDispatch();
  const isFetchingMarket = useSelector(getMarketFetching);
  const marketDisplayName = useSelector(getMarketDisplayName);
  const fetchNameError = useSelector(getFetchNameError);
  const marketNames = toJS(marketDisplayName, []);

  useEffect(() => {
    dispatch(getMarketName());
  }, [dispatch]);

  return [isFetchingMarket, marketNames, fetchNameError];
};

export default useMarketLabel;
